<div class="page">
  <h1 class="page-title">
    {{ orderId ? ('order-summary.edit' | translate:{orderId: orderId, projectType: staticProjectType, projectDescription: staticProjectName}) : ('order-summary.summary' | translate) }}
  </h1>
  <div class="summary-table mg-b-22">
    <table mat-table [dataSource]="cartItems">

      <ng-container matColumnDef="codItem">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 10%;">
          {{ "general.codItem" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.id }}
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>{{ 'order-summary.total' | translate }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="partNumber">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 15%;">
          {{ "general.partNumber" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.partNumber }}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="item">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%;">
          {{ "order-summary.item" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.description }}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>


      <ng-container matColumnDef="kit">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%;">
          Kit
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.kit ? element.kit.description : '-' }}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 15%;">
          {{ "order-summary.category" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.category.category }}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="manufacturer">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 10%;">
          {{ "order-summary.manufacturer" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.manufacturer }}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%; text-align: center;">
          {{ "order-summary.quantity" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field appearance="outline" class="custom-form-field" style="display: block; margin: auto;" subscriptSizing="dynamic">
            <input
              matInput
              type="number"
              min="1"
              [(ngModel)]="element.requestedQuantity"
              (keydown)="blockInvalidCharacters($event)"
              (ngModelChange)="updateQuantity(element)"
              (blur)="element.requestedQuantity = element.requestedQuantity || 0"
              (paste)="blockInvalidPaste($event)" />
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef style="text-align: center;">
          <strong>{{ totalQuantity }}</strong>
        </td>
      </ng-container>


      <ng-container matColumnDef="action">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 5%;">
          {{ "general.action" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="action">
          <button mat-icon-button class="custom-red" (click)="removeItem(element)">
            <mat-icon matTooltip="{{'button.delete-tooltip' | translate}}" style="color: #B41E2A;">
                delete
            </mat-icon>
          </button>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns" [ngClass]="'footer-row'"></tr>
    </table>
  </div>

  <div class="full-width" fxLayoutGap="20px" fxLayout="row">
    <div fxLayout="column" fxFlex="20">
      <h2 class="subtitle mg-b-22">
        {{ 'order-summary.type-request' | translate }}
      </h2>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'order-summary.type-request' | translate }}</mat-label>
        <mat-select required="true" [formControl]="projectType">
          <mat-option value="Projeto">
            {{'orders-dashboard.project' | translate }}
          </mat-option>
          <mat-option value="Spot">
            {{'orders-dashboard.spot' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxLayout="column" fxFlex="80">
      <h2 class="subtitle mg-b-22">
        {{ 'order-summary.description' | translate }}
      </h2>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'order-summary.description' | translate }}</mat-label>
        <input matInput [formControl]="projectDescription"
          maxlength="50" required />
        <mat-hint align="end">
          {{ projectDescription.value?.length || 0 }} / 50
        </mat-hint>
        <mat-error *ngIf="projectDescription.hasError('required') && projectDescription.touched">
          {{ 'order-summary.description-required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div>
      <div fxLayout="column" fxFlex="20">
        <h2 class="subtitle mg-b-22">
          {{ 'order-details.costCenter' | translate }}
        </h2>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'order-details.costCenter' | translate }}</mat-label>
          <input matInput [formControl]="costCenter"
          required />
          <mat-error *ngIf="costCenter.hasError('required') && costCenter.touched">
            O centro de custo do pedido é obrigatório.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

  <h2 class="subtitle mg-b-22">
    {{ 'order-summary.general-order-remarks' | translate }}
  </h2>
  <mat-form-field appearance="outline" class="full-width">
    <textarea
      [formControl]="summaryForm"
      matInput
      maxlength="1000"
    ></textarea>
    <mat-hint align="end">
      {{ summaryForm.value.length }} / 1000
    </mat-hint>
  </mat-form-field>
</div>
<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
